import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../modules/utils/constants/constants';

export const StyledSignatureChefContainer = styled.div`
  .carouselControlType2 .left-arrow,
  .carouselControlType2 .right-arrow {
    height: auto;
  }

  .carouselControlType2 {
    padding-top: ${toRem(48)};

    @media ${baseVariables.mediaQuery.md} {
      padding-top: ${toRem(32)};
    }
  }

  .carouselControlType2 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-wrap: nowrap;
  }

  .carouselControlType2 .glide__arrows:first-of-type {
    margin-right: auto;
    flex: 1 1 auto;
    white-space: nowrap;
  }

  .carouselControlType2 .glide__arrows:last-of-type {
    margin-left: auto;
    flex: 1 1 auto;
    white-space: nowrap;
  }

  .carouselControlType2 [data-glide-el='controls[nav]'] {
    flex: 0 0 auto;
    min-width: 0;
  }

  ${rtl`
        &:is(${constants.RTL_LANG_LIST}) {
        .icon-arrow-left::before {
          transform: scaleX(-1) !important;
        }
        .icon-arrow-right::before {
          transform: scaleX(-1) !important;
        }
      }
    `}
`;
